import { useFormat } from 'helpers/hooks/useFormat';
import { useLocalizedIndex } from 'providers/algolia/localized-index';
import SortFacet from '../facets/sort';

const DesktopSortFacets = () => {
  const { indexName: productsIndex } = useLocalizedIndex({ type: 'products' });

  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  const sortValues = [
    {
      label: formatProductMessage({ id: 'new-products', defaultMessage: 'New' }),
      value: productsIndex,
    },
    {
        label: formatProductMessage({ id: 'nameAsc', defaultMessage: 'Name A-Z' }),
        value: productsIndex.replace('-main', '') + '_name_asc',
    },
    {
        label: formatProductMessage({ id: 'nameDsc', defaultMessage: 'Name Z-A' }),
        value: productsIndex.replace('-main', '') + '_name_desc',
    },
  ]

  return (
      <div className="border border-[#2B2C39] hover:cursor-pointer">
      <SortFacet items={sortValues}/>
      </div>
  );
};

export default DesktopSortFacets;
